import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { EmailFormComponent } from '../email-form/email-form.component';
import { Subscription } from 'rxjs';
import { ResourceBundleService } from '../services/resource-bundle.service';

@Component({
    selector: 'app-email',
    templateUrl: './email.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmailComponent implements OnDestroy {
	@ViewChild(EmailFormComponent) public emailForm: EmailFormComponent;
	@Input() public loggedInEmail: string;

	public errors: { [field: string]: string[] } = {};
	public resourcesSubscription: Subscription;
	public bundle: any;

	constructor(public resourceBundle: ResourceBundleService, private cdRef: ChangeDetectorRef) {
		this.resourcesSubscription = resourceBundle.bundle.subscribe(bundle => {
			this.bundle = bundle;
		});
	}

	validate() {
		const REQUIRED = this.bundle ? this.bundle['error.global.required.info'] : '';
		const MIN_CHARACTERS = this.bundle ? this.bundle['validation.global.minimum.characters.6'] : '';
		const EMAIL_INVALID_FORMAT = this.bundle ? this.bundle['validation.global.email.format'] : '';

		this.errors = { email: [] };
		const email = this.emailForm.formGroup.controls['email'];

		if (email.invalid) {
			if (email?.errors && email?.errors['required']) {
				this.errors['email'].push(REQUIRED);
			} else if (email?.errors && email?.errors['minlength']) {
				this.errors['email'].push(MIN_CHARACTERS);
			} else if (email?.errors && email?.errors['pattern']) {
				this.errors['email'].push(EMAIL_INVALID_FORMAT);
			}
		} else {
			this.errors = {};
		}

		setTimeout(() => this.cdRef.detectChanges());
	}

	isValid(): boolean {
		return this.emailForm.isValid();
	}

	getData(): any {
		return this.emailForm.getData();
	}

	ngOnDestroy(): void {
		this.resourcesSubscription.unsubscribe();
	}
}
